export default __webpack_public_path__ + "static/bg-section-6-81a282e34924e733754484b10cc01283.svg";